module.exports = __webpack_public_path__ + "img/banner.634fdd36.png";